<template>
  <div class='TagManager'>
    <div class="card">
      <div class="label">
        <div class="text-label">
          Google Tag Manager
        </div>
        <div class="arrow">
          <arrow-icon @showSubLinks="newValue => sublink = newValue"/>
        </div>
      </div>
      <div class="cont-input" :class="{ continput: sublink }">
        <div class="cont-i">
          <div class="cont-label">Código inserido no {{ '<head>' }}:</div>
          <textarea rows="5"
          :value="Empresa.tagmanagerhead"
          @change="e => ChangeCompany({ tagmanagerhead: e.target.value })"
          ></textarea>
          <div class="cont-label">Código inserido no {{ '<body>' }}:</div>
          <textarea rows="5"
          :value="Empresa.tagmanagerbody"
          @change="e => ChangeCompany({ tagmanagerbody: e.target.value })"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ArrowIcon from '../Icons/ArrowIcon'
export default {
  name: 'TagManager',
  components: { ArrowIcon },
  data () {
    return {
      sublink: false
    }
  },
  computed: {
    ...mapGetters(['Empresa'])
  },
  methods: {
    ...mapActions(['ChangeCompany'])
  }
}
</script>

<style scoped>
.TagManager {
  display: flex;
  margin-top: 5.8%;
}

.card {
  width: 100%;
  border: thin solid #CCCCCC;
  border-radius: 5px;
  text-align: left;
}

.label {
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  background-color: #EEEEEE;
  color: #648EEA;
  font-size: 16px;
  text-align: left;
}

.text-label {
  width: 90%;
}

.cont-label {
  text-align: left;
  font-size: 12px;
  padding-top: 1%;
  padding-bottom: 1%;
  padding-left: 1%;
}

textarea {
  width: 95%;
  padding: 2%;
  border: thin solid #CCCCCC;
}

textarea:focus {
  outline: none;
}

.text-label {
  padding: 2%;
}

input {
  margin-left: 2%;
}

.cont-input {
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.15s ease-out;
}

.continput {
  max-height: 300px;
  transition: max-height 0.2s ease-in;
}

.cont-i {
  padding: 2%;
}
</style>
